import React, {useState} from 'react';
import {SHARE, SUBMIT_EDIT} from "../../../redux/types";
import css from './Notifications.module.scss'
import infoIcon from '../../../images/info-circle.svg'
import item1 from "../../../images/send.svg";
import item2 from "../../../images/eye_menu.svg";
import item3 from "../../../images/edit.svg";
import item4 from "../../../images/trash.svg";
import {useTheme} from "../../../App";
import {useTranslation} from "react-i18next";
import {dayWithMonth, fromDateToStringDate} from "../../../utils";
import {NavLink} from "react-router-dom";
import {connect} from "react-redux";
import {readNotifications} from "../../../redux/notifications/notifications-thunks";

const Notification = ({notification, readNotifications}) => {
  const {isDark} = useTheme()
  const {t} = useTranslation()
  const {data, is_delivered, type, created_datetime, baseStart, baseFinish, yacht, operator} = notification
  let {voyage} = data
  const [isDelete, setIsDelete] = useState(false)
  return (
    <div className={`${css.notification} ${isDark && css.notification__dark} mr-30`}>
      {!notification.is_delivered && <div className={css.circle} />}
      <div style={{opacity: type === SHARE ? 1 : 0}} className={css.notification__info}>
        <button className={`${css.notification__infoBtn} submenuTrig`}>
          <img src={infoIcon} alt=""/>
        </button>
        {type === SHARE && <div className={`submenu ${css.notification__submenu}`}>
          <p className={css.notification__detail}>{t('tripDetails')}</p>
          <div className={css.notification__row}>
            <p className={css.notification__date}>{t('from')}:</p>
            <p className={css.notification__value}>{(data.sender_first_name || data.sender_last_name) ? `${data.sender_first_name} ${data.sender_last_name}` : data.sender_email}</p>
          </div>
          <div className={css.notification__row}>
            <p className={css.notification__date}>{t('dates')}:</p>
            <p className={css.notification__value}>{fromDateToStringDate(voyage?.start_date)} - {fromDateToStringDate(voyage?.finish_date)}</p>
          </div>
          <div className={css.notification__row}>
            <p className={css.notification__date}>{t('miles')}:</p>
            <p className={css.notification__value}>{voyage?.miles}</p>
          </div>
          <div className={css.notification__row}>
            <p className={css.notification__date}>{t('startBase')}:</p>
            <p className={css.notification__value}>{voyage?.start_marina_name}</p>
          </div>
          <div className={css.notification__row}>
            <p className={css.notification__date}>{t('finishBase')}:</p>
            <p className={css.notification__value}>{voyage?.finish_marina_name}</p>
          </div>
          <div className={css.notification__row}>
            <p className={css.notification__date}>{t('yacht')}:</p>
            <p className={css.notification__value}>{voyage?.yacht_name}</p>
          </div>
          <div className={css.notification__row}>
            <p className={css.notification__date}>{t('operator')}:</p>
            <p className={css.notification__value}>{voyage?.operator_name}</p>
          </div>
        </div>}
      </div>
      <div className={css.notification__content}>
        <div className={css.notification__row}>
          {type === SHARE ?
            <p style={{fontFamily: !is_delivered ? 'Lato700' : 'Lato500'}} className={css.notification__text}>{(data.sender_first_name || data.sender_last_name) ? `${data.sender_first_name} ${data.sender_last_name}` : data.sender_email} {t('sharedYachtTrip')}</p>
            :
            <p className={css.notification__text}>{(data.sender_first_name || data.sender_last_name) ? `${data.sender_first_name} ${data.sender_last_name}` : data.sender_email}} {t('wantsToEdit')} {fromDateToStringDate(voyage?.start_date)} - {fromDateToStringDate(voyage?.finish_date)} {baseStart}. {t('isAccept')}</p>}
          <p className={css.notification__date}>{dayWithMonth(new Date(created_datetime), t)}</p>
        </div>
        <div className={css.notification__row}>
          {type === SHARE ? <p className={css.notification__date}>{fromDateToStringDate(voyage?.start_date)} - {fromDateToStringDate(voyage?.finish_date)} {baseStart}</p>
            : <div/>}
          <div className={css.notification__buttons}>
            {!isDelete ? <>
              {!notification.is_delivered ? <>
                {type === SHARE ? <>
                  <NavLink to={data ? `${data.voyage_accept_link.split('.ua')[1]}&notification=${notification.id}` : null} target={'_blank'}  className="submit-button mr-12">
                    {t('add')}
                  </NavLink>
                  <button onClick={() => setIsDelete(true)} className="reject-button">
                    {t('decline')}
                  </button>
                </> : <>
                  <button className="submit-button">
                    {t('accept')}
                  </button>
                  <button onClick={() => setIsDelete(true)} className="reject-button">
                    {t('decline')}
                  </button>
                </>}
              </> : <p className={css.notification__date}>{notification.is_active ? t('delivered') : t('cancelled')}</p>}
            </> : <>
              <button onClick={() => {
                readNotifications(notification.id, false)
                setIsDelete(false)
              }} className="submit-button">
                {t('yes')}
              </button>
              <button onClick={() => setIsDelete(false)} className="reject-button">
                {t('no')}
              </button>
            </>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, {readNotifications})(React.memo(Notification))
